import * as Models from "../shared/models";
import { CoreLogService } from "../services/log.service";
import { ModelManager } from "./modelManager";

/** spetzielle erweiterung des ModelManager's um WebshopLanguages nach standort und Sprache getrennt zu laden */
export class ModelManagerWebshopLanguages extends ModelManager<Models.WebshopLanguagesDataModel> {

  public constructor(CoreLogService: CoreLogService) {
    super(Models.WebshopLanguagesDataModel, CoreLogService);
  }

}
